import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/contact.module.scss';

import ContactLink from './ContactLink';

const Contact = () => {
  return (
    <section className={Style.contact}>
      <div className={Style.contact__content}>
        <div className={classNames(Style.contact__content__title)}>
          <span>もっと詳しく知りたい</span>
        </div>
        <div className={classNames(Style.contact__content__detail)}>
          詳細をご確認されたい方は、こちらからお問い合わせください。
          <br />
          専任担当者より、詳細をご案内させていただきます。
        </div>
        <div className={Style.contact__btn}>
          <ContactLink text={"お問い合わせ"} />
        </div>
      </div>
    </section>
  );
};

export default Contact;
